// extracted by mini-css-extract-plugin
export var productImage = "_mw-0";